import React from 'react';
import './Loading.css';

function Loading() {
  return (
    <div className='loadingContainer'>
      <div className='loadingContent'>
        <div className='spinnerContainer'>
          <img style={{height:'100px'}} src='https://nimantrana-media.s3.ap-south-1.amazonaws.com/logo.png'></img>
        </div>
        
      </div>
    </div>
  );
}

export default Loading;
